<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { postTrackInfo } from './api';

// @ is an alias to /src
export default {
  name: 'ClassView',
  components: {
    // newHeader,
  },
  data() {
    return {
      timer: null,
      RenWenStay: 0,
      GuiGuStay: 0,
      CeoStay: 0,
      CultureStay: 0,
      AllStayTime: 0,
      currentRoute: ''
    }
  },
  methods: {
    handleBefore(event) {
      let data = {
        type: 23,
        content: JSON.stringify([
          {
            user: this.$store.state.userNumber,
          },
          {
            action: '页面停留'
          }, {
            renwenvalue: this.RenWenStay
          }, {
            guiguvalue: this.GuiGuStay
          }, {
            CEOvalue: this.CeoStay
          }, {
            qiyevalue: this.CultureStay
          },
          {
            msg: this.AllStayTime == 1200 ? '是' : '否'
          }
        ]),
        current: 'OfficialWebsite'

      }
      fetch('https://wxapi.myweixue.com/distribution/system/eventTracking', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        },
        keepalive: true
      })
      /*  fetch('https://apitest.myweixue.com/distribution/system/eventTracking', {
         method: 'POST',
         body: JSON.stringify(data),
         headers: {
           'Content-Type': 'application/json'
         },
         keepalive: true
       }) */
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (this.currentRoute == '/' && this.AllStayTime < 1200) {
          this.RenWenStay++
        } else if (this.currentRoute == '/siliconValley' && this.AllStayTime < 1200) {
          this.GuiGuStay++
        } else if (this.currentRoute == '/youngPerson' && this.AllStayTime < 1200) {
          this.CeoStay++
        } else if (this.currentRoute == '/culture' && this.AllStayTime < 1200) {
          this.CultureStay++
        } else {
          clearInterval(this.timer)
          this.timer = null
        }
        this.AllStayTime = this.RenWenStay + this.GuiGuStay + this.CeoStay + this.CultureStay
      }, 1000)
    },

  },
  mounted() {
    this.$store.dispatch('initializeuserNumber').then(() => {
      let data = {
        type: 18,
        content: JSON.stringify([
          {
            user: this.$store.state.userNumber,
          },
          {
            action: '首页访问'
          }
        ])
   
      }
      console.log(1, '=====>>>>> 1231');
      
      postTrackInfo(data)
    });
    this.currentRoute = this.$route.path
    this.startTimer()
    //监听关闭或刷新
    window.addEventListener('beforeunload', this.handleBefore);
  },
  watch: {
    '$route'(to, from) {
      clearInterval(this.timer)
      this.timer = null
      this.currentRoute = to.path
      this.startTimer()
    }
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('beforeunload', this.handleBefore);
  },

}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  padding: 0;
  margin: 0;
}
</style>
